<template>
  <div v-if="item != null" class="container-visiting">
    <div class="card-title">
      <img src="img/icons_v2/ico-people.png" width="50px" height="50px" />
      <span class="pl-4">คุณกำลังเข้าเยี่ยมร้าน {{ item.customer_name }}</span>
    </div>

    <button class="bt-submit" @click="dialogConfirm = true">
      <i class="icon-Pin"></i>
      Check-Out
    </button>

    <DialogConfirmInOut
      :dialog="dialogConfirm"
      :item="customer"
      :status="false"
      @close="dialogConfirm = false"
      @save="saveCheck"
    />
  </div>
</template>

<script>
import DialogConfirmInOut from './DialogConfirmInOut'
export default {
  components: { DialogConfirmInOut },

  props: ['item', 'user', 'location'],

  emits: ['saveSuccess'],

  data() {
    return {
      dialogConfirm: false
    }
  },

  computed: {
    customer() {
      return this.item
    }
  },

  methods: {
    saveCheck(item) {
      this.dialogConfirm = false

      const formData = {
        user_id: this.user.id,
        customer_id: item.customer_id,
        lat_lng: this.location
      }

      this.$store.dispatch('checkinout/getCheckInOut', { formData }).then((res) => {
        const status = res.status
        if (status == 200) {
          Swal.fire({
            icon: 'success',
            title: `${res.message}`,
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.$emit('saveSuccess')
          })
        } else {
          Swal.fire({
            width: 650,
            icon: 'warning',
            title: `ไม่สารถเช็คเอาท์ได้`,
            html: `${res.message}`,
            showConfirmButton: false,
            timer: 3500
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container-visiting {
  display: flex;
  align-items: center;
  justify-items: center;
  background-color: #3f4d57;
  justify-content: space-between;
  color: white;
  height: 100px;
  width: 100%;
  padding: 30px;
}

.card-title {
  width: 70%;
  max-width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 15px;
}

.bt-submit {
  width: 24%;
  background-color: #a50200;
  color: #ffffff;
  font-size: 25px;
  height: 65px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-Pin:before {
  font-size: 35px;
  color: #ffffff !important;
}

button:active,
button:focus {
  outline: none;
}
</style>
